export enum POPUP_TYPE {
  NONE,
  ALARM_CONFIRM,
  ALARM_NOT_EXPOSE,
  ALARM_COMPLETE,
  ALARM_TRADE_COMPLETE,
  ALARM_TRADE_CONTINUE,
  ALARM_ARTICLE_COMPLETE_TRADE_CANCEL,
  ALARM_ARTICLE_EXPOSURE_TRADE_CANCEL,
  ALARM_MODIFY_AGENT,
  ALARM_MODIFY_CANCEL,
  ALARM_EXPOSURE_END,
  ALARM_CHANGE_TRADE_COMPLETE,
  ALARM_EXPOSURE_END_BY_TRADE_COMPLETE,
  ALARM_CONTINUE_EXPOSURE,
  ALARM_REQUEST_FAIL,
  ALARM_NOT_ACCESS_ARTICLE_EXPOSURE_CONFIRM,
}

export const POPUP_MESSAGE: Record<POPUP_TYPE, { title: string; text?: string }> = {
  [POPUP_TYPE.NONE]: { title: '', text: '' },
  [POPUP_TYPE.ALARM_CONFIRM]: {
    title: '매물이 확인되었습니다.',
    text: '매물이 확인되어 네이버페이 부동산에서 노출됩니다.',
  },
  [POPUP_TYPE.ALARM_NOT_EXPOSE]: {
    title: '매물을 내놓지 않으셨나요?',
    text: '확인 버튼을 누르면 네이버페이 부동산에서 동일 주소로 노출중인 모든 매물이 노출 종료로 변경됩니다.',
  },
  [POPUP_TYPE.ALARM_COMPLETE]: {
    title: '매물이 거래 완료되었나요?',
    text: '확인 버튼을 누르면 네이버페이 부동산에서 동일 주소로 노출중인 모든 매물이 거래 완료로 변경됩니다.',
  },
  [POPUP_TYPE.ALARM_TRADE_COMPLETE]: {
    title: '매물이 거래 완료되었나요?',
    text: '확인 버튼을 누르면 네이버페이 부동산에서 동일 주소로 노출중인 모든 매물이 거래 완료로 변경됩니다.',
  },
  [POPUP_TYPE.ALARM_TRADE_CONTINUE]: {
    title: '매물이 거래 중인가요?',
    text: '확인 버튼을 누르면 네이버페이 부동산에서 동일 주소로 노출 중인 모든 매물이 계속 노출됩니다.',
  },
  [POPUP_TYPE.ALARM_ARTICLE_COMPLETE_TRADE_CANCEL]: {
    title: '매물이 거래 가능한가요?',
    text: '확인 버튼을 누르면 네이버페이 부동산에서 동일 주소로 노출 중인 모든 매물이 계속 노출됩니다.',
  },
  [POPUP_TYPE.ALARM_ARTICLE_EXPOSURE_TRADE_CANCEL]: {
    title: '매물이 거래 가능한가요?',
    text: '확인 버튼을 누르면 네이버페이 부동산에서 동일 주소로 노출 중인 모든 매물이 계속 노출됩니다.',
  },
  [POPUP_TYPE.ALARM_MODIFY_AGENT]: {
    title: '중개사무소에 요청사항을 전달하였습니다.',
  },
  [POPUP_TYPE.ALARM_MODIFY_CANCEL]: {
    title: '매물 정보 수정 요청을 취소하시겠습니까?',
  },
  [POPUP_TYPE.ALARM_EXPOSURE_END]: {
    title: '동일 주소로 등록된 모든 매물이 노출 종료되었습니다.',
  },
  [POPUP_TYPE.ALARM_CHANGE_TRADE_COMPLETE]: {
    title: '동일 주소로 등록된 모든 매물이 거래 완료로 변경되었습니다.',
  },
  [POPUP_TYPE.ALARM_EXPOSURE_END_BY_TRADE_COMPLETE]: {
    title: '동일 주소로 등록된 모든 매물이 거래 완료로 노출 종료되었습니다.',
  },
  [POPUP_TYPE.ALARM_CONTINUE_EXPOSURE]: {
    title: '동일 주소로 등록된 모든 매물이 계속 노출됩니다.',
  },
  [POPUP_TYPE.ALARM_REQUEST_FAIL]: {
    title: '일시적인 오류로 정상적인 처리가 되지 않았습니다. 잠시 후 다시 시도해주세요',
  },
  [POPUP_TYPE.ALARM_NOT_ACCESS_ARTICLE_EXPOSURE_CONFIRM]: {
    title: '매물이 노출 종료되어 매물 확인 페이지로 이동할 수 없습니다.',
  },
}
